import React from "react"
import { Container, Row, Col } from 'react-bootstrap'
import CTAMenuLink from "../../../modules/cta_menu_link_module"

const TopMenu = ({data}) => {

  return (
    <>
    {data?.links?.length > 0 && 
      <div className="primary-header d-none d-xl-flex">
          <Container>
            <Row>
              <Col>
                <ul>
                  {data?.links?.map((item, index) => {
                    return(
                      <li key={item}><CTAMenuLink item={item} /></li>
                    )
                  })}                  
                </ul>
              </Col>
            </Row>
          </Container>
      </div>
      }
    </>
  )
}



export default TopMenu